import type { FormCustomRenderer } from '@packages/form-engine/types/renderer';

import { customRecurrenceEndsRenderer } from './components/customRecurrenceEndsRenderer';

export const JOB_SCHEDULER_RECURRENCE_FORM_SCHEMA_ID =
  'wealthlane://forms/job-scheduler-recurrence' as const;

export const jobSchedulerRecurrenceFormCustomRenderers: Record<string, FormCustomRenderer> = {
  'custom-recurrence-ends': customRecurrenceEndsRenderer,
};

/** Form-engine custom nodes for a compose form block, keyed by block `$id` / schema URI. */
export function customRenderersForFormSchemaId(
  schemaId: string,
): Record<string, FormCustomRenderer> | undefined {
  if (schemaId === JOB_SCHEDULER_RECURRENCE_FORM_SCHEMA_ID) {
    return jobSchedulerRecurrenceFormCustomRenderers;
  }
  return undefined;
}
